export enum CheckInTaskGroup {
  Unknown = 'Unknown',
  AudioVideo = 'AudioVideo',
  Consents = 'Consents',
  CommissionSelection = 'CommissionSelection',
  SignerDetails = 'SignerDetails',
  IdVerification = 'IdVerification',
  SecurityQuestions = 'SecurityQuestions',
  SignatureCreation = 'SignatureCreation',
}
